import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Pagination from "../../common/TablePagination";
import "../../Fundraiser/Withdrawals/WithdrawmoneyTransactions.scss";
import { useDispatch, useSelector } from "react-redux";
import { getWithdrawals } from "../../../services/fundraiserService";
import { separateDateTimeAndConvertToLocale } from "../../../utils/utilFunctions";

const WithdrawalsDataTable = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.adminReducer?.loading);
  const credit = useSelector((state) => state?.adminReducer?.transactions?.credit);

  const filtered = React.useMemo(() => {
    const q = (searchQuery || '').toLowerCase().trim();
    if (!q) return credit || [];
    return (credit || []).filter((row) => {
      const values = [
        row?._id,
        separateDateTimeAndConvertToLocale(row?.createdAt)?.localDate,
        row?.user?.name,
        row?.fundraiser?.user?.name,
        String(row?.totalFunds / 100),
        String(row?.adminFunds / 100),
      ];
      return values.some((v) => String(v || '').toLowerCase().includes(q));
    });
  }, [credit, searchQuery]);
  const [allWithdrawals, setAllWithdrawals] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [disableNext, setDisableNext] = useState(false);

  // const getAllWithdrawals = async (endingBefore, startingAfter) => {
  //   if (endingBefore !== undefined) {
  //     const withdrawalsPromise = await dispatch(
  //       getWithdrawals({ endingBefore: endingBefore })
  //     )?.unwrap();
  //     if (
  //       withdrawalsPromise?.success === true &&
  //       withdrawalsPromise?.data?.length > 0
  //     ) {
  //       setAllWithdrawals(withdrawalsPromise?.data);
  //     } else {
  //       setDisableNext(true);
  //     }
  //   } else if (startingAfter !== undefined) {
  //     const withdrawalsPromise = await dispatch(
  //       getWithdrawals({ startingAfter: startingAfter })
  //     )?.unwrap();
  //     if (
  //       withdrawalsPromise?.success === true &&
  //       withdrawalsPromise?.data?.length > 0
  //     ) {
  //       setAllWithdrawals(withdrawalsPromise?.data);
  //     } else {
  //       setDisableNext(true);
  //     }
  //   } else {
  //     const withdrawalsPromise = await dispatch(getWithdrawals())?.unwrap();
  //     if (
  //       withdrawalsPromise?.success === true &&
  //       withdrawalsPromise?.data?.length > 0
  //     ) {
  //       setAllWithdrawals(withdrawalsPromise?.data);
  //     } else {
  //       setDisableNext(true);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   getAllWithdrawals();
  // }, []);

  const columns = [
    {
      name: "ID",
    },
    {
      name: "Date",
    },
    {
      name: "User Name",
    },
    {
      name: "Fundraiser",
    },
    {
      name: "Subscription Amount",
    },
    {
      name: "Funds",
    },
  ];

  // const handlePreviousChange = () => {
  //   getAllWithdrawals(allWithdrawals[0]?.id, undefined);
  //   setCurrentPage((prevPage) => prevPage - 1);
  // };

  // const handleNextChange = () => {
  //   getAllWithdrawals(
  //     undefined,
  //     allWithdrawals[allWithdrawals?.length - 1]?.id
  //   );
  //   setCurrentPage((prevPage) => prevPage + 1);
  // };

  return (
    <div className="col-span-12">
      {/* Desktop Table */}
      <TableContainer className="w-[100%] hidden md:block">
        <Table
          sx={{ borderCollapse: "separate", borderSpacing: "0px 8px", minWidth: "800px" }}
          aria-label="simple table"
        >
          <TableHead className="bg-[#00ADEF] ">
            <TableRow
              className="h-[50px]"
              sx={{ boxShadow: "0px 4px 4px 0px #00000040" }}
            >
              {columns.map((column) => {
                return (
                  <TableCell className="!text-[#FFFFFF] !font-[500] !text-[14px]">
                    {column.name}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {filtered && filtered?.length > 0 ? (
              filtered?.map((withdrawal, index) => (
                <TableRow
                  className="h-[50px]"
                  sx={{
                    boxShadow: "0px 4px 4px 0px #00000040",
                    backgroundColor:
                      (index + 1) % 2 !== 0 ? "#F5F5F5" : "#FFFFFF",
                  }}
                >
                  <TableCell className="max-w-[100px] truncate">{withdrawal?._id}</TableCell>
                  <TableCell className="max-w-[80px] truncate">
                    {
                      separateDateTimeAndConvertToLocale(withdrawal?.createdAt)
                        ?.localDate
                    }
                  </TableCell>
                  <TableCell className="max-w-[80px] truncate">{withdrawal?.user?.name}</TableCell>
                  <TableCell className="max-w-[100px] truncate">
                    {
                      withdrawal?.fundraiser?.user?.name
                    }
                  </TableCell>
                  <TableCell className="max-w-[80px] truncate">${(withdrawal?.totalFunds / 100).toFixed(2)}</TableCell>
                  <TableCell className="max-w-[80px] truncate">${(withdrawal?.adminFunds / 100).toFixed(2)}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={columns.length}
                  align="center"
                  className="text-[16px] font-poppins font-[400] text-gray-500"
                >
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Mobile Card View */}
      <div className="block md:hidden space-y-4 mt-4">
        {filtered && filtered?.length > 0 ? (
          filtered?.map((withdrawal, index) => (
            <div
              key={index}
              className="bg-white rounded-[10px] p-4 border border-[#E0E0E0] shadow-sm flex flex-col gap-3"
            >
              <div className="flex justify-between items-start">
                <div className="flex-1 min-w-0">
                  <p className="text-[11px] font-[400] text-[#8C8C8C] font-poppins">Transaction ID</p>
                  <h3 className="text-[14px] font-[600] text-[#303030] font-poppins truncate">
                    {withdrawal?._id}
                  </h3>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3 text-[13px] font-poppins text-[#303030]">
                <div className="flex flex-col">
                  <span className="text-[#8C8C8C] text-[11px]">Date</span>
                  <span className="truncate">
                    {separateDateTimeAndConvertToLocale(withdrawal?.createdAt)?.localDate || "N/A"}
                  </span>
                </div>
                <div className="flex flex-col">
                  <span className="text-[#8C8C8C] text-[11px]">User Name</span>
                  <span className="truncate">{withdrawal?.user?.name || "N/A"}</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-[#8C8C8C] text-[11px]">Fundraiser</span>
                  <span className="truncate">{withdrawal?.fundraiser?.user?.name || "N/A"}</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-[#8C8C8C] text-[11px]">Subscription</span>
                  <span className="truncate font-[600] text-[#00ADEF]">
                    ${(withdrawal?.totalFunds / 100).toFixed(2)}
                  </span>
                </div>
                <div className="flex flex-col col-span-2">
                  <span className="text-[#8C8C8C] text-[11px]">Funds</span>
                  <span className="truncate font-[600] text-[#00ADEF]">
                    ${(withdrawal?.adminFunds / 100).toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="bg-white rounded-[10px] p-8 border border-[#E0E0E0] text-center">
            <p className="text-[16px] font-poppins font-[400] text-gray-500">
              No data found
            </p>
          </div>
        )}
      </div>

      <Pagination totalPages={undefined} disableNext={disableNext} />
    </div>
  );
};

export default WithdrawalsDataTable;